import { render, staticRenderFns } from "./courseListView_new.vue?vue&type=template&id=4cd156a8&scoped=true"
import script from "./courseListView_new.vue?vue&type=script&lang=js"
export * from "./courseListView_new.vue?vue&type=script&lang=js"
import style0 from "./courseListView_new.vue?vue&type=style&index=0&id=4cd156a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd156a8",
  null
  
)

export default component.exports